module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAALBJREFUOE/NkrsNwkAQRN9UQEQAOZDSAbTlBpCpCjqgBCQaQCJ0MnCWbflzZyw58cY772bnRswczdSzEIDtHHhLuk45yfYF+EjKZXsNPIAtkP2DVOIMeALHMgPbO+AObMYgPfFZ0qsJ0fYeuKUgMXF4vPMLKUhKPABU53ScAKtwVnVzabsddLQHLSch2DAhsIE46qCmtyDFL5tT/+V6b7SJtg9AISk4iM5CqjylvqmdL9vRTRwDmVVwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-arrow-icon.png
// module id = ntVl
// module chunks = 12